// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "./node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "./node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat&family=Roboto&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Import Google Fonts */

/* Define custom variables */
:root {
  /* Colors */
  --blue-color: #3b82f6;
  --red-color: #ef4444;
  --yellow-color: #eab308;
  --green-color: #22c55e;
  --white-color: #fff;
  --neutral-color: #d4d4d4;
  --light-black: #0000005e;
  --dark-blue: #2563eb;

  /* Standard pxs */
  --x-big: 64px;
  --big: 32px;
  --normal: 16px;
  --small: 8px;
  --x-small: 4px;

  /* Others */
  --shadow-style-1: 1px 2px 3px var(--light-black);
  --shadow-style-2: 0 0 var(--small) var(--light-black);
  --shadow-style-3: -1px -1px 1px var(--light-black);

  --add-icon-size-1: 56px;
  --add-icon-size-2: 50px;
}

/* Apply general styling and reset */
html {
  box-sizing: border-box;
  position: relative;
}

*,
*::before,
*::after {
  box-sizing: inherit;
  margin: 0;
  padding: 0;
}

h1,
h2,
h3 {
  font-family: "Montserrat", sans-serif;
}

input,
button,
textarea,
select {
  font: inherit;
  padding: var(--x-small);
  border-radius: var(--x-small);
  border: none;
}

/* Style body element */
body {
  font-family: "Roboto", sans-serif;
  background-color: var(--neutral-color);
  display: grid;
  grid-template-columns: 1fr 4fr;
}

/* Style sidebar section of app */
aside {
  background-color: var(--blue-color);
  color: var(--white-color);
  padding: var(--big);
}

aside .logo-link {
  color: inherit;
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: var(--small);
  margin-bottom: var(--normal);
}

.logo-link .mdi {
  font-size: 48px;
}

aside nav {
  margin-left: 56px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: var(--small);
}

nav div {
  padding: var(--small);
  border-radius: var(--x-small);
  transition: transform 0.3s, background-color 0.3s;
}

nav div:hover {
  transform: scale(1.05);
  background-color: var(--dark-blue);
}

nav div:active {
  transform: scale(0.95);
}

.focus {
  background-color: var(--dark-blue);
}

/* Style main section of app */
main {
  min-height: 100vh;
  padding: var(--x-small) var(--normal);
}

.container {
  margin-top: var(--small);
  display: flex;
  flex-direction: column;
  align-items: center;
}

.content {
  align-self: flex-start;
  margin-top: var(--big);
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: var(--normal);
  margin-bottom: calc(var(--x-big) + (2 * var(--normal)));
  width: 100%;
}

.empty {
  font-style: italic;
  display: flex;
  margin-top: 40vh;
  justify-content: center;
}

.todo,
.project {
  background-color: var(--white-color);
  border-radius: var(--small);
  padding: var(--small);
  box-shadow: var(--shadow-style-1);
  border-left: var(--small) solid var(--blue-color);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: var(--x-small);
  transition: background-color 0.3s, box-shadow 0.3s;
}

.todo.completed,
.project.completed {
  background-color: var(--neutral-color);
  box-shadow: var(--shadow-style-2);
}

.todo .title,
.project .name {
  align-self: center;
}

.priority-and-parent-project-name,
.controls,
.controls div {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.priority,
.incomplete-todos,
.completed-todos {
  font-weight: 900;
  text-shadow: var(--shadow-style-3);
}

.incomplete-todos,
.completed-todos {
  text-shadow: var(--shadow-style-2);
}

.priority.high,
.incomplete-todos {
  color: var(--red-color);
}

.priority.medium {
  color: var(--yellow-color);
}

.priority.low,
.completed-todos {
  color: var(--green-color);
}

.parent-project-name,
.todos {
  font-weight: 900;
  font-style: italic;
}

input[type="checkbox"] {
  width: calc(var(--big) - var(--small));
  height: calc(var(--big) - var(--small));
}

.controls div {
  gap: var(--small);
}

.todo .mdi,
.project .mdi {
  padding: var(--x-small);
  border-radius: var(--x-small);
  font-size: calc(var(--big) - var(--small));
  transition: background-color 0.3s, transform 0.3s;
}

.todo .mdi:hover,
.project .mdi:hover {
  background-color: var(--light-black);
}

.todo .mdi:active,
.project .mdi:active {
  transform: scale(0.9);
}

.add-icon {
  position: absolute;
  bottom: var(--big);
  right: var(--big);
  display: flex;
  justify-content: center;
  align-items: center;
  width: var(--add-icon-size-1);
  height: var(--add-icon-size-1);
  box-shadow: var(--shadow-style-2);
  border-radius: 50%;
  cursor: pointer;
  transition: transform 0.3s;
}

.add-icon:hover {
  transform: scale(1.1);
}

.add-icon:active {
  transform: scale(0.9);
}

.add-icon .mdi {
  font-size: var(--add-icon-size-1);
}

dialog {
  margin: auto;
  border: none;
  outline: none;
  padding: var(--normal);
  background-color: var(--neutral-color);
  border-radius: var(--small);
  box-shadow: var(--shadow-style-1);
  width: max(300px, 30%);
}

dialog form {
  display: flex;
  flex-direction: column;
  gap: var(--normal);
}

form .form-group {
  display: flex;
  flex-direction: column;
}

.buttons {
  display: flex;
  justify-content: flex-end;
  gap: var(--small);
}

button {
  color: var(--white-color);
  padding: var(--small);
  transition: transform 0.3s;
}

button:hover {
  transform: scale(1.1);
}

button:active {
  transform: scale(0.9);
}

button[type="button"] {
  background-color: var(--light-black);
}

button[type="submit"] {
  background-color: var(--blue-color);
}

dialog[open] {
  animation: fade-in 0.5s ease-in forwards;
}

dialog[open]::backdrop {
  animation: backdrop-fade-in 0.5s ease-in forwards;
}

/* Animation keyframes */
@keyframes fade-in {
  0% {
    opacity: 0;
  }
}

@keyframes backdrop-fade-in {
  0% {
    background-color: rgba(0, 0, 0, 0);
  }

  100% {
    background-color: var(--light-black);
  }
}

@media screen and (max-width: 425px) {
  body {
    display: block;
  }

  aside {
    display: flex;
    flex-direction: column;
  }

  aside .logo-link {
    margin: auto;
  }

  aside nav {
    flex-direction: row;
    margin: auto;
  }

  main {
    min-height: 70vh;
  }

  .content {
    align-self: center;
    max-width: 300px;
  }

  .empty {
    margin-top: 20vh;
  }

  .add-icon {
    width: var(--add-icon-size-2);
    height: var(--add-icon-size-2);
    right: var(--normal);
    bottom: var(--normal);
  }

  .add-icon .mdi {
    font-size: var(--add-icon-size-2);
  }
}
`, "",{"version":3,"sources":["webpack://./index.css"],"names":[],"mappings":"AAAA,wBAAwB;;AAGxB,4BAA4B;AAC5B;EACE,WAAW;EACX,qBAAqB;EACrB,oBAAoB;EACpB,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;EACnB,wBAAwB;EACxB,wBAAwB;EACxB,oBAAoB;;EAEpB,iBAAiB;EACjB,aAAa;EACb,WAAW;EACX,cAAc;EACd,YAAY;EACZ,cAAc;;EAEd,WAAW;EACX,gDAAgD;EAChD,qDAAqD;EACrD,kDAAkD;;EAElD,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA,oCAAoC;AACpC;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;;;EAGE,mBAAmB;EACnB,SAAS;EACT,UAAU;AACZ;;AAEA;;;EAGE,qCAAqC;AACvC;;AAEA;;;;EAIE,aAAa;EACb,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA,uBAAuB;AACvB;EACE,iCAAiC;EACjC,sCAAsC;EACtC,aAAa;EACb,8BAA8B;AAChC;;AAEA,iCAAiC;AACjC;EACE,mCAAmC;EACnC,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;EAC7B,iDAAiD;AACnD;;AAEA;EACE,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;AACpC;;AAEA,8BAA8B;AAC9B;EACE,iBAAiB;EACjB,qCAAqC;AACvC;;AAEA;EACE,wBAAwB;EACxB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,aAAa;EACb,4DAA4D;EAC5D,kBAAkB;EAClB,uDAAuD;EACvD,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;EAEE,oCAAoC;EACpC,2BAA2B;EAC3B,qBAAqB;EACrB,iCAAiC;EACjC,iDAAiD;EACjD,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,mBAAmB;EACnB,kDAAkD;AACpD;;AAEA;;EAEE,sCAAsC;EACtC,iCAAiC;AACnC;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;;EAGE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;;;EAGE,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,sCAAsC;EACtC,uCAAuC;AACzC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,uBAAuB;EACvB,6BAA6B;EAC7B,0CAA0C;EAC1C,iDAAiD;AACnD;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,6BAA6B;EAC7B,8BAA8B;EAC9B,iCAAiC;EACjC,kBAAkB;EAClB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,sCAAsC;EACtC,2BAA2B;EAC3B,iCAAiC;EACjC,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,iDAAiD;AACnD;;AAEA,wBAAwB;AACxB;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,kCAAkC;EACpC;;EAEA;IACE,oCAAoC;EACtC;AACF;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,6BAA6B;IAC7B,8BAA8B;IAC9B,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,iCAAiC;EACnC;AACF","sourcesContent":["/* Import Google Fonts */\n@import url(\"https://fonts.googleapis.com/css2?family=Montserrat&family=Roboto&display=swap\");\n\n/* Define custom variables */\n:root {\n  /* Colors */\n  --blue-color: #3b82f6;\n  --red-color: #ef4444;\n  --yellow-color: #eab308;\n  --green-color: #22c55e;\n  --white-color: #fff;\n  --neutral-color: #d4d4d4;\n  --light-black: #0000005e;\n  --dark-blue: #2563eb;\n\n  /* Standard pxs */\n  --x-big: 64px;\n  --big: 32px;\n  --normal: 16px;\n  --small: 8px;\n  --x-small: 4px;\n\n  /* Others */\n  --shadow-style-1: 1px 2px 3px var(--light-black);\n  --shadow-style-2: 0 0 var(--small) var(--light-black);\n  --shadow-style-3: -1px -1px 1px var(--light-black);\n\n  --add-icon-size-1: 56px;\n  --add-icon-size-2: 50px;\n}\n\n/* Apply general styling and reset */\nhtml {\n  box-sizing: border-box;\n  position: relative;\n}\n\n*,\n*::before,\n*::after {\n  box-sizing: inherit;\n  margin: 0;\n  padding: 0;\n}\n\nh1,\nh2,\nh3 {\n  font-family: \"Montserrat\", sans-serif;\n}\n\ninput,\nbutton,\ntextarea,\nselect {\n  font: inherit;\n  padding: var(--x-small);\n  border-radius: var(--x-small);\n  border: none;\n}\n\n/* Style body element */\nbody {\n  font-family: \"Roboto\", sans-serif;\n  background-color: var(--neutral-color);\n  display: grid;\n  grid-template-columns: 1fr 4fr;\n}\n\n/* Style sidebar section of app */\naside {\n  background-color: var(--blue-color);\n  color: var(--white-color);\n  padding: var(--big);\n}\n\naside .logo-link {\n  color: inherit;\n  text-decoration: none;\n  display: flex;\n  align-items: center;\n  gap: var(--small);\n  margin-bottom: var(--normal);\n}\n\n.logo-link .mdi {\n  font-size: 48px;\n}\n\naside nav {\n  margin-left: 56px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: var(--small);\n}\n\nnav div {\n  padding: var(--small);\n  border-radius: var(--x-small);\n  transition: transform 0.3s, background-color 0.3s;\n}\n\nnav div:hover {\n  transform: scale(1.05);\n  background-color: var(--dark-blue);\n}\n\nnav div:active {\n  transform: scale(0.95);\n}\n\n.focus {\n  background-color: var(--dark-blue);\n}\n\n/* Style main section of app */\nmain {\n  min-height: 100vh;\n  padding: var(--x-small) var(--normal);\n}\n\n.container {\n  margin-top: var(--small);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.content {\n  align-self: flex-start;\n  margin-top: var(--big);\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));\n  gap: var(--normal);\n  margin-bottom: calc(var(--x-big) + (2 * var(--normal)));\n  width: 100%;\n}\n\n.empty {\n  font-style: italic;\n  display: flex;\n  margin-top: 40vh;\n  justify-content: center;\n}\n\n.todo,\n.project {\n  background-color: var(--white-color);\n  border-radius: var(--small);\n  padding: var(--small);\n  box-shadow: var(--shadow-style-1);\n  border-left: var(--small) solid var(--blue-color);\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  gap: var(--x-small);\n  transition: background-color 0.3s, box-shadow 0.3s;\n}\n\n.todo.completed,\n.project.completed {\n  background-color: var(--neutral-color);\n  box-shadow: var(--shadow-style-2);\n}\n\n.todo .title,\n.project .name {\n  align-self: center;\n}\n\n.priority-and-parent-project-name,\n.controls,\n.controls div {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.priority,\n.incomplete-todos,\n.completed-todos {\n  font-weight: 900;\n  text-shadow: var(--shadow-style-3);\n}\n\n.incomplete-todos,\n.completed-todos {\n  text-shadow: var(--shadow-style-2);\n}\n\n.priority.high,\n.incomplete-todos {\n  color: var(--red-color);\n}\n\n.priority.medium {\n  color: var(--yellow-color);\n}\n\n.priority.low,\n.completed-todos {\n  color: var(--green-color);\n}\n\n.parent-project-name,\n.todos {\n  font-weight: 900;\n  font-style: italic;\n}\n\ninput[type=\"checkbox\"] {\n  width: calc(var(--big) - var(--small));\n  height: calc(var(--big) - var(--small));\n}\n\n.controls div {\n  gap: var(--small);\n}\n\n.todo .mdi,\n.project .mdi {\n  padding: var(--x-small);\n  border-radius: var(--x-small);\n  font-size: calc(var(--big) - var(--small));\n  transition: background-color 0.3s, transform 0.3s;\n}\n\n.todo .mdi:hover,\n.project .mdi:hover {\n  background-color: var(--light-black);\n}\n\n.todo .mdi:active,\n.project .mdi:active {\n  transform: scale(0.9);\n}\n\n.add-icon {\n  position: absolute;\n  bottom: var(--big);\n  right: var(--big);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: var(--add-icon-size-1);\n  height: var(--add-icon-size-1);\n  box-shadow: var(--shadow-style-2);\n  border-radius: 50%;\n  cursor: pointer;\n  transition: transform 0.3s;\n}\n\n.add-icon:hover {\n  transform: scale(1.1);\n}\n\n.add-icon:active {\n  transform: scale(0.9);\n}\n\n.add-icon .mdi {\n  font-size: var(--add-icon-size-1);\n}\n\ndialog {\n  margin: auto;\n  border: none;\n  outline: none;\n  padding: var(--normal);\n  background-color: var(--neutral-color);\n  border-radius: var(--small);\n  box-shadow: var(--shadow-style-1);\n  width: max(300px, 30%);\n}\n\ndialog form {\n  display: flex;\n  flex-direction: column;\n  gap: var(--normal);\n}\n\nform .form-group {\n  display: flex;\n  flex-direction: column;\n}\n\n.buttons {\n  display: flex;\n  justify-content: flex-end;\n  gap: var(--small);\n}\n\nbutton {\n  color: var(--white-color);\n  padding: var(--small);\n  transition: transform 0.3s;\n}\n\nbutton:hover {\n  transform: scale(1.1);\n}\n\nbutton:active {\n  transform: scale(0.9);\n}\n\nbutton[type=\"button\"] {\n  background-color: var(--light-black);\n}\n\nbutton[type=\"submit\"] {\n  background-color: var(--blue-color);\n}\n\ndialog[open] {\n  animation: fade-in 0.5s ease-in forwards;\n}\n\ndialog[open]::backdrop {\n  animation: backdrop-fade-in 0.5s ease-in forwards;\n}\n\n/* Animation keyframes */\n@keyframes fade-in {\n  0% {\n    opacity: 0;\n  }\n}\n\n@keyframes backdrop-fade-in {\n  0% {\n    background-color: rgba(0, 0, 0, 0);\n  }\n\n  100% {\n    background-color: var(--light-black);\n  }\n}\n\n@media screen and (max-width: 425px) {\n  body {\n    display: block;\n  }\n\n  aside {\n    display: flex;\n    flex-direction: column;\n  }\n\n  aside .logo-link {\n    margin: auto;\n  }\n\n  aside nav {\n    flex-direction: row;\n    margin: auto;\n  }\n\n  main {\n    min-height: 70vh;\n  }\n\n  .content {\n    align-self: center;\n    max-width: 300px;\n  }\n\n  .empty {\n    margin-top: 20vh;\n  }\n\n  .add-icon {\n    width: var(--add-icon-size-2);\n    height: var(--add-icon-size-2);\n    right: var(--normal);\n    bottom: var(--normal);\n  }\n\n  .add-icon .mdi {\n    font-size: var(--add-icon-size-2);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
